export * from '@erp/ui/skeleton';
